import { WritableAutoConfiguratorState } from '../slice';

export function incrementPendingRecalculations(
  state: WritableAutoConfiguratorState,
) {
  state.pendingRecalculationCount += 1;
}

export function decrementPendingRecalculations(
  state: WritableAutoConfiguratorState,
) {
  state.pendingRecalculationCount = Math.max(
    0,
    state.pendingRecalculationCount - 1,
  );
}
